import { useDispatch, useSelector } from "react-redux";

import Makuleringer from "./Makuleringer";

import { setSort as setSortAction } from "../../../actions/advancedListActions";
import { getMakuleringer as getRapportMakuleringerAction } from "../../../actions/rapporter/makuleringerActions";

function MakuleringerPage(ownProps) {
  const dispatch = useDispatch();
  const makuleringerFilterForm = useSelector(
    (state) => state.forms.makuleringerFilterForm,
  );
  const makuleringerSubmittedForm = useSelector(
    (state) => state.submittedForms.makuleringerSubmittedForm,
  );
  const makuleringerRapport = useSelector(
    (state) => state.rapporter.makuleringerRapport,
  );
  const sort = useSelector((state) => state.rapporter.makuleringerRapport.sort);

  const page =
    makuleringerRapport && makuleringerRapport.page
      ? makuleringerRapport.page
      : 1;
  const pageSize =
    makuleringerRapport && makuleringerRapport.count
      ? makuleringerRapport.count
      : 1;

  const onSort = (newSort) => {
    dispatch(setSortAction("RAPPORTER.MAKULERINGERRAPPORT", newSort));
    dispatch(
      getRapportMakuleringerAction(
        makuleringerFilterForm,
        page,
        pageSize,
        newSort,
      ),
    );
  };

  return (
    <Makuleringer
      {...ownProps}
      makuleringerSubmittedForm={makuleringerSubmittedForm}
      makuleringerRapport={makuleringerRapport}
      sort={sort}
      onSort={onSort}
    />
  );
}

export default MakuleringerPage;
